/** @module Operations/Review/ConclusionViewController */
define([
    "dojo/_base/declare",
    "dojo/store/Memory",
    "underscore",
    "csi/locale",
    "csi/xml",
    "SiteAdmin/SubtypedDataSheet"
], function(declare,Memory,_,locale,xml,SubtypedDataSheet) {

	var REVIEW_STATES = ["Draft","Pending","Approved"];

    return declare(SubtypedDataSheet, {
		/**
		 * Return store of possible states for custom view defaults
		 * @return {Memory}
		 */
        getCustomViewNodeContextsStore: function() {
            return new Memory({
                idProperty: "id",
                labelProperty: "name",
                data: _.map(REVIEW_STATES, function(state) {
                    return {
                        id: state,
                        name: locale.resource("OperationsReviewState:" + state)
                    };
                }),
				stateNode: true,
            });
        },

        /**
         * Allow different default custom view per state
         */
        onViewCreate: function() {
            var node = this.getViewNode();
            if (node) {
                this.prefNodeContext = xml.enumGetText(node.State);
            }
        }
    });
});